import React from "react";
import {
  BarChart,
  // Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  // CartesianGrid,
  Bar,
  Label,
  // Area,
  ResponsiveContainer,
} from "recharts";

const BarGraph = ({ datum }) => {
  const data = datum?.data?.deposits?.map(({ name, MPesa, Payroll }) => ({
    name,
    MPesa,
    "Check-off": Payroll,
  }));
  return (
    <ResponsiveContainer>
      <BarChart width={500} height={200} data={data} margin={{ left: 10 }}>
        <XAxis dataKey="name" axisLine={{ stroke: "#000000" }} />
        <YAxis axisLine={{ stroke: "#000000" }}>
          <Label value="Amount" angle={-90} offset={-5} position="insideLeft" />
        </YAxis>
        <Tooltip />
        <Legend />
        <Bar dataKey="MPesa" fill="#005C53" />
        <Bar dataKey="Check-off" fill="#359D93" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarGraph;
